import { render, staticRenderFns } from "./TheNav.vue?vue&type=template&id=a967b53e&scoped=true&"
var script = {}
import style0 from "./TheNav.vue?vue&type=style&index=0&id=a967b53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a967b53e",
  null
  
)

export default component.exports